<template>
  <div class="surepage">
    <div class="surebg">
      <div class="topboxcon" v-show="!active">
        <span class="block">
          <img src="../../assets/images/addcard.png" alt class="nonenum">
        </span>
        <span class="block addguide">挂号请添加就诊卡</span>
        <span class="addCardBtn" @click="addcard">
          <img src="../../assets/images/addpic.png" alt>
          <span>添加就诊卡</span>
        </span>
      </div>
      <div class="navcon" v-show="active">
        <div class="surecardinfo clearfix">
          <div class="surecode">
            <img class="twocode" :src="headimgurl" alt>
          </div>
          <div class="surecode codeinfo clearfix">
            <p>{{userinfo.Name}}&nbsp;&nbsp;&nbsp;{{userinfo.Sex}}</p>
            <P>档案号：{{userinfo.PatNo}}</P>
          </div>
        </div>
        <div class="cut">
          <img src="../../assets/images/qiehuan.png" class="qiehuan" alt>
          <span @click="swichtcard">切换就诊卡</span>
        </div>
      </div>
    </div>
    <div class="flexbox">
      <div class="surlist">
        <span class="listline"></span>
        <p>
          <span class="title">挂号信息</span>
        </p>
        <p>
          <span>就诊科室：</span>
          <span>{{doctorInfo.Dpt_Name}}</span>
        </p>
        <p>
          <span>就诊诊室：</span>
          <span>{{doctorSelect.RoomName}}</span>
        </p>
        <p>
          <span>就诊医生：</span>
          <span>{{doctorSelect.Name}}</span>
        </p>
        <p>
          <span>就诊日期：</span>
          <span>{{doctorSelect.ScheRecoTime | scheRecoTimeFilters}}</span>
        </p>
        <p>
          <span>预估就诊时间：</span>
          <span>{{estimatedTime}}</span>
        </p>
        <p>
          <span>挂号费用：</span>
          <span>￥{{doctorSelect.RegAmount}}</span>
        </p>
        <p>
          <span>诊室区域：</span>
          <span>{{doctorSelect.Address}}</span>
        </p>
      </div>
      <div class="prompt">
        <p>温馨提示：</p>
        <p>1.预约挂号使用的就诊卡必须是就诊用户本人，否则视为挂号无效。</p>
        <p>2.【取消预约】挂号成功后如需退号，请于就诊前{{backNumberTime}}小时前在手机APP上取消预约，就诊当日不支持手机退号，需到窗口进行退号操作，若退号时间超过预约就诊日期的工作开始时间，手机APP和医院收费窗口一律不能退号。</p>
        <p>3.支付后需等待微信反馈提示，若提示成功方可认为挂号成功，若失败，费用会在3个工作日内原路返还，若无提示需等待确认。也可在APP中查看挂号状态（查看方式：【个人中心】-【挂号记录】-挂号记录列表页-【状态：待就诊】）</p>
        <p>4.请在预约就诊时间前持本人身份证、就诊卡、病历本等进行签到。</p>
      </div>
    </div>
    <div class="surebnt" @click="surefun">
      <span>确定挂号</span>
    </div>
  </div>
</template>
<script>
import {
  GetItem,
  DeletePayRecord,
  WeiXinCharge,
  GetWXUserInfo,
  GetEstimatedTime,
  GetHISAddRegModel,
  AddHisCharge
} from "@/services/getData.js";
import weui from "weui.js";
import moment from "moment";
export default {
  name: "register-sure",
  data() {
    return {
      doctorSelect: [],
      doctorInfo: [],
      userinfo: {},
      active: false,
      headimgurl: "",
      estimatedTime: "0:00",
      backNumberTime: GetItem("backNumberTime"),
      $dialog: []
    };
  },
  created: function() {
    this.doctorSelect = JSON.parse(GetItem("doctorSelect"));
    this.doctorInfo = JSON.parse(GetItem("doctorInfo"));
    this.userinfo = this.$store.state.userInfo;
    if (GetItem("patid") == null) {
      this.active = false;
    } else {
      this.active = true;
    }
    this.getEstimatedTime();
    this.getWXUserInfo();
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  methods: {
    getEstimatedTime() {
      GetEstimatedTime(
        this.doctorInfo.Dpt_ID,
        this.doctorInfo.GUID,
        this.doctorSelect.ScheRecoTime,
        this.doctorSelect.ScheRecoDeta_ID
      ).then(response => {
        this.estimatedTime = response.data;
      });
    },
    getWXUserInfo() {
      GetWXUserInfo().then(response => {
        this.headimgurl = response.data.headimgurl;
      });
    },
    surefun() {
      this.hisAddReg();
      //跳转到挂号成功页
      //this.$router.push({ path: '/register/registersus', params: { userId: 123 } });
    },
    addcard() {
      //跳转到添加就诊卡页
      this.$router.push({ name: "AddCard", params: { active: true } });
    },
    swichtcard() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    hisAddReg() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      if (GetItem("patid") == null) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请先添加就诊卡，需实名认证后方可使用此功能"
        });
        loading.hide();
        return;
      }
      var sendData = GetHISAddRegModel(
        this.doctorInfo.Dpt_ID,
        this.doctorInfo.GUID,
        this.doctorSelect.ScheRecoTime,
        this.doctorSelect.ScheRecoDeta_ID
      );
      var _that = this;
      WeiXinCharge(sendData).then(data => {
        var returnString = data.split("_");
        if (returnString[0] == "ok") {
          loading.hide();
          this.$router.push({
            path: "/register/registersus",
            query: { outOrder: returnString[1]}
          });
          // AddHisCharge(returnString[1]).then(response => {
          //   loading.hide();
          //   if (response.data.Result) {
          //   } else {
          //     _that.$dialog = weui.dialog({
          //       title: "提示",
          //       content: response.data.Content
          //     });
          //   }
          // });
        } else if (returnString[0] == "cancel") {
          DeletePayRecord(returnString[1]).then(response => {
            loading.hide();
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "fail") {
          DeletePayRecord(returnString[1]).then(response => {
            loading.hide();
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "no") {
          loading.hide();
        } else {
          loading.hide();
        }
      });
    }
  },
  filters: {
    scheRecoTimeFilters: function(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  }
};
</script>
<style>
.topboxcon .addCardBtn {
  padding: 0.02rem 0.2rem;
  border: 0.01rem solid #1592e4;
}
.topboxcon .addCardBtn > img {
  display: inline-block;
  width: 0.2rem;
  height: 0.18rem;
}
.topboxcon .addguide {
  color: #999999;
  font-size: 0.22rem;
  margin-bottom: 0.12rem;
}
.surepage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.surepage .prompt {
  margin-left: 0.2rem;
  font-size: 0.2rem;
  color: #999999;
  margin-top: 0.2rem;
}
.surepage > .flexbox {
  flex: 1;
  overflow: auto;
}

.surepage .surebg {
  background: url("../../assets/images/beijing.png") no-repeat, #f2f2f2;
  background-size: 100% 66%;
  box-sizing: border-box;
  padding: 0.2rem;
}

.surepage .navcon {
  flex: 1;
  border: 0.4rem;
  border-color: #dddddd;
  height: 2.4rem;
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  position: relative;
  box-shadow: 0 0.03rem 0.08rem 0 rgba(200, 214, 223, 1);
  border-radius: 0.08rem;
}

.surepage .surecardinfo {
  padding-left: 0.38rem;
  padding-bottom: 0.28rem;
  border-bottom: 0.01rem dotted #dcdcdc;
}

.surepage .surecode {
  float: left;
}

.surepage .navcon .twocode {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin-top: 0.29rem;
  margin-right: 0.29rem;
  border-radius: 0.15rem;
}

.surepage .codeinfo > p:first-child {
  color: #333333;
  font-size: 0.3rem;
  text-align: left !important;
  margin-top: 0.42rem;
}

.surepage .codeinfo > p:last-child {
  color: #999999;
  font-size: 0.3rem;
  text-align: left !important;
}

.surepage .cut {
  box-sizing: border-box;
  padding-top: 0.2rem;
}

.surepage .qiehuan {
  width: 0.32rem;
  height: 0.32rem;
  display: inline-block;
  vertical-align: text-bottom;
}

.surepage .surebnt {
  background-color: #1592e4;
  height: 0.8rem;
  margin: 0.2rem;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  color: #fffefe;
  text-align: center;
  line-height: 0.8rem;
}

.surepage .surlist {
  padding: 0 0.2rem;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
}

.surepage .surlist > p {
  width: 100%;
  border-bottom: 0.01rem solid #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.surepage .surlist > p > span:first {
  color: #333333;
  text-align: left;
}

.surepage .surlist > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}

.surepage .surlist > p > .title {
  color: #1592e4 !important;
  float: left !important;
}

.surepage .surlist .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}

.topboxcon {
  flex: 1;
  overflow: hidden;
  margin: 0.2rem;
  border: 0.4rem;
  border-color: #dddddd;
  height: 2.4rem;
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  position: relative;
  box-shadow: 0 0.03rem 0.08rem 0 rgba(200, 214, 223, 1);
  border-radius: 0.08rem;
}

.block {
  display: block;
}

.topboxcon .nonenum {
  width: 0.81rem;
  height: 0.81rem;
  margin-top: 0.3rem;
  margin-left: 42%;
  margin-bottom: 0.1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/register/register-sure.vue